import React, { useState } from "react";
import "./OrderInfo.css";
import classNames from "classnames";
import { SERVICES_BASE_URL } from "../../utils/Constants";

const OrderInfo = ({
  currentOrderNumber = -1,
  cartContent,
  shippingMethod,
  weight,
  scannedWeight,
  isAuto,
  flexGrow,
  fromAFrameControl,
  showOrderNumber,
  showWeight,
  sortID,
  latestShipping,
  isRxOrder,
  currentCartShelf = "",
  nextCartShelf = "",
  shippingHasIDCheck = false,
  sortType = -1,
  rxOrderSku = null,
  rxAuto = false,
  orderInfo = null,
  boxWeightModel,
  orderStatus = null,
  showTimerAndOrderInfo = false,
}) => {
  const [hoverWeight, setHover] = useState(false);
  const onHover = (e) => {
    e.preventDefault();
    setHover(true);
  };
  const onHoverOver = (e) => {
    e.preventDefault();
    setHover(false);
  };

  if (orderInfo !== null && orderInfo.SortBoxID <= 0) {
    return null;
  }
  if (
    (cartContent !== null && currentOrderNumber !== -1 && !isAuto) ||
    (showOrderNumber && currentOrderNumber !== -1)
  ) {
    const classes = classNames({
      OrderInfocard: true,
      OrderInfocarTimerAndOrderInfo: showTimerAndOrderInfo,
      red: weight > 2000,
      green: weight <= 2000,
      blue: fromAFrameControl,
      flexGrow: flexGrow,
      OrderInfoCardAFrame: fromAFrameControl,
      OrderInfocardFlex: isRxOrder,
      OrderInfocardRXAuto: rxAuto,
    });

    const rowClasses = classNames({
      orderInfoRow: !flexGrow,
      orderBigInfoRow: flexGrow,
    });

    const shippingContainerClasses = classNames({
      shippingContainer: true,
      shippingContainerAFrame: fromAFrameControl,
    });

    return (
      <div className={classes}>
        {!rxAuto ? (
          <div className={rowClasses}>
            <span>{rxOrderSku ? "RX-order ID" : "Ordernummer"}:</span>{" "}
            {showOrderNumber ? (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  "https://la.site.se/Order" + (isRxOrder ? "rx" : "") + "/" + currentOrderNumber
                }
              >
                {rxOrderSku ? rxOrderSku : currentOrderNumber}
              </a>
            ) : rxOrderSku ? (
              rxOrderSku
            ) : (
              currentOrderNumber
            )}
          </div>
        ) : null}
        {orderStatus && orderStatus !== "Kontrollerad" ? (
          <div className={rowClasses}>
            <b className="orderInfoWarning">Varning orderstatus är {orderStatus.toLowerCase()}</b>
          </div>
        ) : null}
        {showWeight ? (
          <div className={rowClasses}>
            <span>Vikt:</span>
            {boxWeightModel !== null ? (
              <span onMouseEnter={(e) => onHover(e)} onMouseLeave={(e) => onHoverOver(e)}>
                <b>{boxWeightModel.weight}</b>/{boxWeightModel.estimatedWeight}
                {hoverWeight && (
                  <div className="orderInfoWeightInterval">
                    {boxWeightModel.weightMin}-{boxWeightModel.weightMax}g
                  </div>
                )}
              </span>
            ) : (
              <span>
                <b>{scannedWeight || 0}</b>/{weight}
              </span>
            )}
            g
          </div>
        ) : !rxAuto ? (
          <div className={rowClasses}>
            <span>Lista:</span>{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                "https://la.site.se/Monitor/Picklist?sortID=" +
                sortID +
                (isRxOrder ? "&isRx=true" : "")
              }
            >
              {sortID}
            </a>
          </div>
        ) : null}
        {fromAFrameControl && latestShipping ? (
          <div className={rowClasses}>
            <span>Levereras ut senast: </span> {latestShipping}
          </div>
        ) : null}
        {shippingMethod ? (
          <div className="orderInfoShipping">
            <div className={shippingContainerClasses}>
              {shippingMethod !== undefined ? (
                <img
                  alt="shippingmethodlogo"
                  src={`${SERVICES_BASE_URL}/images/shipping-method/large/${shippingMethod}.png`}
                ></img>
              ) : null}
            </div>
          </div>
        ) : null}
        {isRxOrder && currentCartShelf !== "" && !rxAuto ? (
          <div className={rowClasses}>
            <span>Nuvarande fack: </span> {currentCartShelf}
          </div>
        ) : null}
        {isRxOrder && sortType !== 1 && nextCartShelf !== "-1" && !rxAuto ? (
          <div className={rowClasses}>
            <span>Nästa fack: </span> {nextCartShelf}
          </div>
        ) : null}
        {isRxOrder && currentCartShelf !== "" ? (
          <div className={rowClasses}>
            <span>Fraktsätt har IDKoll: </span> {shippingHasIDCheck ? "JA" : "NEJ"}
          </div>
        ) : null}
      </div>
    );
  }
  return null;
};

export default OrderInfo;
